// extracted by mini-css-extract-plugin
module.exports = {"dilutionInput":"SelectDilusionRate_dilutionInput__1tfxH","dilutionDropdown":"SelectDilusionRate_dilutionDropdown__1bES3","iconDropDown":"SelectDilusionRate_iconDropDown__3L6qV"};